"use client"

import { useScript } from "@uidotdev/usehooks"
import { useEffect, useState } from "react"
import { Loader } from "~/components/ui/icons/loader"
import { env } from "~/env"

declare global {
  interface Window {
    Canny: (fn: string, options?: unknown) => void
  }
}

export const CannyBoard = ({ token: boardToken }: { token: string }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const status = useScript("https://canny.io/sdk.js", { removeOnUnmount: false })
  const basePath = "/features"

  useEffect(() => {
    if (window.Canny) {
      window.Canny("identify", {
        appID: env.NEXT_PUBLIC_CANNY_APP_ID,
      })

      window.Canny("render", {
        basePath,
        boardToken,
        onLoadCallback: () => setIsLoaded(true),
      })
    }
  }, [status, basePath, boardToken])

  return <div data-canny>{!isLoaded && <Loader className="mx-auto" />}</div>
}
